<style lang="less">
  @import './login.less';
</style>

<template>
  <div class="login">
    <div class="login-con">
      <Card icon="log-in" title="欢迎登录" :bordered="false">
        <div class="form-con">
          <login-form @on-success-valid="handleSubmit"></login-form>
          <p class="login-tip">忘记密码请联系管理员</p>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import LoginForm from '_c/login-form'
import { mapActions } from 'vuex'
export default {
  components: {
    LoginForm
  },
  methods: {
    ...mapActions([
      'handleLogin',
      'getUserInfo'
    ]),
    handleSubmit ({ username, password }) {
      this.handleLogin({ username, password }).then(res => {
        this.getUserInfo().then(res => {
          // 根据用户权限动态选择首页
          const userAccess = this.$store.state.user.access
          const defaultHome = this.getDefaultHomeByAccess(userAccess)
          this.$router.push({
            name: defaultHome
          })
        })
      })
    },
    getDefaultHomeByAccess(access) {
      // 根据用户权限返回合适的首页
      if (access.includes('admin') || access.includes('Operation Management')) {
        return 'home' // 管理员和运营管理跳转到原首页
      } else if (access.includes('customer')) {
        return 'server_list' // 客户权限跳转到设备列表
      } else {
        return 'home' // 默认跳转到首页
      }
    }
  }
}
</script>

<style>

</style>
